import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import AvatarView from '../../../business-components/Avatar/AvatarView'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTitulo,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosSubTotalTitulo,
    formataTableCellBodyExibeDadosSubTotalTexto,
    formataTableCellBodyExibeDadosSubTotalValor,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem8,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    DivOverflowXTabelaPadrao,
} from '../../../business-components/Div/Div'

import {
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    ButtonVisualizarApolices,
} from '../../../business-components/Button/Button'

import {
    SvgImageCoracao,
} from '../../../business-components/SvgImage/SvgImage'

/*
import {
    SvgImageParceirosPortoSeguroLogo
} from '../../../../business-components/SvgImage/Parceiros/PortoSeguro/SvgImageParceirosPortoSeguro' 

import {
    SvgImageParceirosSulAmericaLogo
} from '../../../../business-components/SvgImage/Parceiros/SulAmerica/SvgImageParceirosSulAmerica' 
*/

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import morteInvalidezEstudoList from '../../../business-rules/List/morteInvalidezEstudoList'

import {
    AIFT
} from '../aiFT-form/AIFTComp'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    calculaValorCS,
} from '../seguroVida-form/SeguroVidaService'

import {
    GridContainerEstudoPadraoMd,
} from './EstudoComp'

import EstudoFormSeguroVida from '../estudo-form/EstudoFormSeguroVida'



const EstudoFormProtecaoSugerida = ( { variaveisGlobais, values, estudo, vars, titulo, idClienteConjuge, report } ) => {

    const ProtecaoSugerida = () => {
        
        const protecaoSugerida =
            idClienteConjuge === HARDCODE.idFamiliarCliente ? values.protecaoSugeridaCliente : values.protecaoSugeridaConjuge
        
        const idadeMorteAte =
            idClienteConjuge === HARDCODE.idFamiliarCliente ? values.idadeSimulacaoMorteCliente : values.idadeSimulacaoMorteConjuge

        const morteAte = pesquisaList(morteInvalidezEstudoList(values, idadeMorteAte), "A").descricaoResumida

        const ajuste = !(morteAte && values.exibirMorteAte && !values.naoExibirMorteVitalicia) && report ? 0 : 1
        const aumentoLetraCabecalho = 4 - ajuste
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 0/*3*/ - ajuste : 2/*5*/ - ajuste
        
        const aumentoLetra = 4 - ajuste
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 - ajuste : 6 - ajuste
    
        let headList = [
            {
                colSpan: 8,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoCoberturaSeguroVida, report, false,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]

        if (morteAte && values.exibirMorteAte) {

            if (values.naoExibirMorteVitalicia) {

                headList.push(
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                            LABEL.necessidadeProtecao + "<br/>" + morteAte +
                                (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                            LABEL.apolices + "<br/>" + morteAte +
                                (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )

            }

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        (values.naoExibirMorteVitalicia ? LABEL.valorCSAdicional : LABEL.valorCS) + "<br/>" + morteAte +
                            (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tempoCoberturaSeguroVida, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values, true),
                },
            )
        }

        if (!morteAte || !values.naoExibirMorteVitalicia) {

            if (!morteAte || !values.exibirMorteAte) {

                headList.push(
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.necessidadeProtecao + "<br/>" +
                            pesquisaList(morteInvalidezEstudoList(values), "M").descricao + 
                                (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                    {
                        colSpan: 4,
                        headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.apolices + "<br/>" +
                            pesquisaList(morteInvalidezEstudoList(values), "M").descricao + 
                                (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                    },
                )
            }

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        (!morteAte || !values.exibirMorteAte ? LABEL.valorCSAdicional : LABEL.valorCS) + "<br/>" +
                            pesquisaList(morteInvalidezEstudoList(values), "M").descricao + 
                                (!values.naoExibirInvalidez ? " / " + LABEL.invalidez : ""), report,
                                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tempoCoberturaSeguroVida, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values, true),
                },
            )
        }

        let avatar = false

        familiaresList(values)?.forEach((item, ind) => {
            if (
                    item.avatar &&
                    item.id !== idClienteConjuge
                    //(
                    //    (idClienteConjuge === HARDCODE.idFamiliarCliente && item.id !== HARDCODE.idFamiliarCliente) ||
                    //    (idClienteConjuge === HARDCODE.idFamiliarConjuge && item.id !== HARDCODE.idFamiliarConjuge)
                    //)
            ) {
                
                avatar = true
            }
        })

        return (
            <>
                {avatar && (!vars.jsonConfiguracao ||
                (!vars.jsonConfiguracao.naoExibirCoracaoProtecaoSugerida &&
                (!vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao))) && (
                    <GridContainer
                        className='justify-center mt-1 mb-2'
                    >
                        <GridItem1
                            className='mt-6'
                        >
                            <SvgImageCoracao/>
                        </GridItem1>

                        {familiaresList(values)?.map((item, ind) => {
                            return item.avatar &&
                                item.id !== idClienteConjuge
                                /*((idClienteConjuge === HARDCODE.idFamiliarCliente && item.id !== HARDCODE.idFamiliarCliente) ||
                                (idClienteConjuge === HARDCODE.idFamiliarConjuge && item.id !== HARDCODE.idFamiliarConjuge))*/ ? (
                                    <GridItem2
                                        key={ind}
                                        align='center'
                                    >
                                        <AvatarView
                                            width={110}
                                            height={110}
                                            value={item.avatar}
                                        />
                                    </GridItem2>
                                )
                                :
                                (
                                    <div
                                        key={ind}
                                    />
                                )
                        })}

                        <GridItem1
                            className='mt-6'
                        >
                            <SvgImageCoracao/>
                        </GridItem1>
                    </GridContainer>
                )}
                
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados>
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {protecaoSugerida?.map((item, ind) => {
                        
                            let colSpan = 0

                            return (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {item.detalhamento === "N"
                                            ?
                                                formataTableCellBodyExibeDadosSubTotalTitulo(item.descricao, report, false, aumentoLetra,
                                                    aumentoLetraReport, values)
                                            :
                                                formataTableCellBodyExibeDadosTitulo(item.descricao, report, false, false,
                                                    aumentoLetra, aumentoLetraReport, values)
                                        }
                                    </TableCellBodyExibeDados>

                                    {morteAte && values.exibirMorteAte && (
                                        <>
                                            {values.naoExibirMorteVitalicia && (
                                                <>
                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalValor(item.valorNecessidade1, report, false, aumentoLetra, aumentoLetraReport, values)
                                                            :
                                                                formataTableCellBodyExibeDadosValor(item.valorNecessidade1, report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>

                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalValor(item.valorApolices1, report, false, aumentoLetra, aumentoLetraReport, values)
                                                            :
                                                                formataTableCellBodyExibeDadosValor(item.valorApolices1, report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>
                                                </>
                                            )}

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.detalhamento === "N"
                                                    ?
                                                        formataTableCellBodyExibeDadosSubTotalValor(item.valorCS1, report, false, aumentoLetra, aumentoLetraReport, values)
                                                    :
                                                        formataTableCellBodyExibeDadosValor(item.valorCS1, report, false, false, aumentoLetra, aumentoLetraReport, values, true)
                                                }
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.tempoCoberturaSeguroVida1
                                                    ?
                                                        item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalTexto(item.tempoCoberturaSeguroVida1, report, aumentoLetra, aumentoLetraReport, values, true)
                                                            :
                                                                formataTableCellBodyExibeDadosTexto(item.tempoCoberturaSeguroVida1, report, false, aumentoLetra, aumentoLetraReport, values, true)
                                                    :
                                                        ''
                                                }
                                            </TableCellBodyExibeDados>
                                        </>
                                    )}

                                    {(!morteAte || !values.naoExibirMorteVitalicia) && (
                                        <>
                                            {(!morteAte || !values.exibirMorteAte) && (
                                                <>
                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalValor(item.valorNecessidade2, report, false, aumentoLetra, aumentoLetraReport, values)
                                                            :
                                                                formataTableCellBodyExibeDadosValor(item.valorNecessidade2, report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>

                                                    <TableCellBodyExibeDados
                                                        colSpan={headList[colSpan++].colSpan}
                                                    >
                                                        {item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalValor(item.valorApolices2, report, false, aumentoLetra, aumentoLetraReport, values)
                                                            :
                                                                formataTableCellBodyExibeDadosValor(item.valorApolices2, report, false, false, aumentoLetra, aumentoLetraReport, values)
                                                        }
                                                    </TableCellBodyExibeDados>
                                                </>
                                            )}

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.detalhamento === "N"
                                                    ?
                                                        formataTableCellBodyExibeDadosSubTotalValor(item.valorCS2, report, false, aumentoLetra, aumentoLetraReport, values)
                                                    :
                                                        formataTableCellBodyExibeDadosValor(item.valorCS2, report, false, false, aumentoLetra, aumentoLetraReport, values, true)
                                                }
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {item.tempoCoberturaSeguroVida2
                                                    ?
                                                        item.detalhamento === "N"
                                                            ?
                                                                formataTableCellBodyExibeDadosSubTotalTexto(item.tempoCoberturaSeguroVida2, report, aumentoLetra, aumentoLetraReport, values, true)
                                                            :
                                                                formataTableCellBodyExibeDadosTexto(item.tempoCoberturaSeguroVida2, report, false, aumentoLetra, aumentoLetraReport, values, true)
                                                    :
                                                        ''
                                                }
                                            </TableCellBodyExibeDados>
                                        </>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>  
            </>
        )
    }


    const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo



    return (
        report || relatorioModoApresentacao(values)
            ?
                <div
                    //className={
                    //    relatorioModoApresentacao(values)
                    //        ?
                    //            ''//'mb-5 mt-10 ml-5 mr-5'
                    //        :
                    //            ''//'mt-0'
                                //idClienteConjuge === HARDCODE.idFamiliarCliente
                                //    ?
                                //       values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato
                                //            ?
                                //                'mt--7'
                                //            :
                                //                'mt-0'
                                //    : 
                                //        'mt-2'
                    //} // mudança da fonte: acrescentou mt-10
                >
                    <GridItem12
                        className='mb-1'
                    >
                        <CardGridDivH4Destaque
                            align="center"
                            report={report}
                        >
                            {/*LABEL.protecaoSugerida + ": " + */titulo}
                        </CardGridDivH4Destaque>
                    </GridItem12>
                    
                    <ProtecaoSugerida />
                </div>
            :
                <GridContainerEstudoPadraoMd
                    component={
                        <div
                            className={values.modoApresentacao ? idClienteConjuge === HARDCODE.idFamiliarConjuge ? 'mt-15' : 'mt--5' : ''}
                        >
                            <CardGridEstudoAux>
                                <CardGridDivHeaderDestaque1
                                    semBackground={values.modoApresentacao}
                                >
                                    <GridContainer>
                                        <GridItem8>
                                            <CardGridDivH4Destaque>
                                                {LABEL.protecaoSugerida + ": " + titulo}
                                            </CardGridDivH4Destaque>
                                        </GridItem8>

                                        <GridItem3>
                                            {calculaValorCS(values, idClienteConjuge, null, null) > 0 && (
                                                <CustomizedDialogsPopup
                                                    maxWidth='lg'
                                                    popupTitle={LABEL.buttonVisualizarApolices}
                                                    PopupButton={ButtonVisualizarApolices}
                                                    //bgDefault={true}
                                                    popupComponent={
                                                        <EstudoFormSeguroVida
                                                            values={values}
                                                            estudo={estudo}
                                                            idClienteConjuge={idClienteConjuge}
                                                        />
                                                    }
                                                />
                                            )}
                                        </GridItem3>

                                        <GridItem1>
                                            <AIFT
                                                aiFTOrigem={
                                                    idClienteConjuge === HARDCODE.idFamiliarCliente
                                                        ?
                                                            HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaCliente
                                                        :
                                                            HARDCODE.analisesInformacoesEstudoFormProtecaoSugeridaConjuge
                                                }
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                estudo={estudo}
                                                vars={vars}
                                            />
                                        </GridItem1>
                                    </GridContainer>
                                </CardGridDivHeaderDestaque1>

                                <CardGridDivBody>
                                    <DivOverflowXTabelaPadrao>
                                        <ProtecaoSugerida />
                                    </DivOverflowXTabelaPadrao>
                                </CardGridDivBody>
                            </CardGridEstudoAux>
                        </div>
                    }
                />
    )
}

export default EstudoFormProtecaoSugerida